module.exports = __webpack_public_path__ + "img/lens-150-plus-01.bbebc51c.png";